import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, observable, makeObservable, runInAction, action } from "mobx";
import DPServices from "@dp/services";
import MobileAccordionModel from "./models/MobileAccordionModel";
import i18next from "i18next";
import { TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES, isTrue, PlatformType } from "@dp/common";
import { OTAModel } from "./models";
import BrandRules from "../utils/BrandRules";
import moment from "moment";
import { getUniqueSessionID, TOGO_DELIVERY_ERROR_POP_UP_TYPE } from "../utils";
var Common = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Common, _Base);

  var _super = _createSuper(Common);

  function Common(rootStore) {
    var _this;

    _classCallCheck(this, Common);

    _this = _super.call(this);

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_timeAtAppActive", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_orderID", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "accordionModel", null);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "otaModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_deliveryErrorPopUp", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_userChoice", _descriptor5, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "promptResolveForTOGODeliveryFlow", void 0);

    _this.rootStore = rootStore;
    _this.accordionModel = new MobileAccordionModel(_this.rootStore.platformUtil);

    if (_this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
      _this.otaModel = new OTAModel(_this.rootStore.platformUtil);
    }

    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Common, [{
    key: "setupReactions",
    value: function setupReactions() {
      return;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var appAttributes, _appAttributes$config, _this$rootStore, _this$rootStore$platf, webAuthConfigs, authorityBase, clientId, knownAuthorities, policies, _appAttributes$config2, _appAttributes$config3, _this$rootStore2, _this$rootStore2$plat, appAuthConfigs;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return DPServices.Common.getAppAttributes();

              case 2:
                appAttributes = _context.sent;
                DPServices.Config.setConceptCode(appAttributes.currentConceptCode); // Inialize the msal auth instance based on values for app init for web

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB)) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 5;

                if (!(appAttributes !== null && appAttributes !== void 0 && (_appAttributes$config = appAttributes.configs) !== null && _appAttributes$config !== void 0 && _appAttributes$config.webAuthConfig)) {
                  _context.next = 11;
                  break;
                }

                webAuthConfigs = JSON.parse(appAttributes.configs.webAuthConfig);
                authorityBase = webAuthConfigs.authorityBase, clientId = webAuthConfigs.clientId, knownAuthorities = webAuthConfigs.knownAuthorities, policies = webAuthConfigs.policies;
                _context.next = 11;
                return (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$platf = _this$rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.createAuthInstance({
                  authorityBase: authorityBase,
                  clientId: clientId,
                  knownAuthorities: knownAuthorities,
                  policies: policies
                });

              case 11:
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](5);

              case 15:
                _context.next = 26;
                break;

              case 17:
                _context.prev = 17;

                if (!(appAttributes !== null && appAttributes !== void 0 && (_appAttributes$config2 = appAttributes.configs) !== null && _appAttributes$config2 !== void 0 && _appAttributes$config2.appAuthConfig)) {
                  _context.next = 22;
                  break;
                }

                appAuthConfigs = JSON.parse(appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config3 = appAttributes.configs) === null || _appAttributes$config3 === void 0 ? void 0 : _appAttributes$config3.appAuthConfig);
                _context.next = 22;
                return (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$plat = _this$rootStore2.platformUtil) === null || _this$rootStore2$plat === void 0 ? void 0 : _this$rootStore2$plat.createAuthInstance(appAuthConfigs);

              case 22:
                _context.next = 26;
                break;

              case 24:
                _context.prev = 24;
                _context.t1 = _context["catch"](17);

              case 26:
                _context.next = 28;
                return this.rootStore.user.checkUserInitialLoggedInStatus();

              case 28:
                _context.next = 30;
                return this.rootStore.user.getAndSetSessionDetails();

              case 30:
                runInAction(function () {
                  _this2._appAttributes = appAttributes;
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 13], [17, 24]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "getCurbsideTokenIdentifier",
    value: function getCurbsideTokenIdentifier() {
      var _this$rootStore3, _this$rootStore3$user, _this$rootStore4, _this$rootStore4$user, _this$rootStore4$user2, _this$rootStore4$user3;

      var isUserLoggedIn = (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.isLoggedIn;
      var TOKEN_IDENTIFIER = isUserLoggedIn ? (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : (_this$rootStore4$user2 = _this$rootStore4$user.userProfile) === null || _this$rootStore4$user2 === void 0 ? void 0 : (_this$rootStore4$user3 = _this$rootStore4$user2.login) === null || _this$rootStore4$user3 === void 0 ? void 0 : _this$rootStore4$user3.toUpperCase() : "ANONYMOUS";
      return TOKEN_IDENTIFIER;
    }
  }, {
    key: "redirectToMyReservations",
    value: function () {
      var _redirectToMyReservations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _BrandRules, _this$_appAttributes, _this$rootStore7, _this$rootStore7$plat, bottomTabsContainReservations, _this$rootStore5, _this$rootStore5$plat, _this$rootStore6, _this$rootStore6$plat;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                bottomTabsContainReservations = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.bottomTabsContainReservations();

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context4.next = 5;
                  break;
                }

                if (bottomTabsContainReservations) {
                  (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$plat = _this$rootStore5.platformUtil) === null || _this$rootStore5$plat === void 0 ? void 0 : _this$rootStore5$plat.navigateToRoute("/ReservationsWithTopTabsInBottomTab", [{
                    name: "tabIndex",
                    value: 1
                  }]);
                } else {
                  (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$plat = _this$rootStore6.platformUtil) === null || _this$rootStore6$plat === void 0 ? void 0 : _this$rootStore6$plat.navigateToRoute("/ReservationsWithTopTabsAsAScreen", [{
                    name: "tabIndex",
                    value: 1
                  }]);
                }

                return _context4.abrupt("return");

              case 5:
                (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.goToURL("/reservations?tab=my-reservations");
                _context4.next = 10;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function redirectToMyReservations() {
        return _redirectToMyReservations.apply(this, arguments);
      }

      return redirectToMyReservations;
    }()
  }, {
    key: "trackSession",

    /**
     *  If there is no session ID one will be created (New Session)
        This session ID will be valid for based on sessionIDExpirationThreshold (default 20 min)
        This validation  tracking will happen only
          - WEB: if window minimised, maximised , tab switch , Page refresh 
          - App: initial launch, App moved between foreground , background 
        if sessionIDExpirationThreshold passed new session ID will be generated. 
     */
    value: function () {
      var _trackSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$rootStore8, _this$rootStore8$user, _this$rootStore8$user2, _currentSessionData, _currentSessionData2, _currentSessionData3, currentSessionData, _this$rootStore9, _this$rootStore9$plat, _this$rootStore10, _this$rootStore10$use, _this$rootStore10$use2, storedData, timeout, currentTime, lastRequestFiredTime, _this$rootStore11, _this$rootStore11$com, _this$rootStore11$com2, _this$rootStore11$com3, _this$rootStore12, _this$rootStore12$pla, _this$rootStore13, _this$rootStore13$use, _this$rootStore13$use2, id, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                currentSessionData = (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : (_this$rootStore8$user2 = _this$rootStore8$user.analyticsModel) === null || _this$rootStore8$user2 === void 0 ? void 0 : _this$rootStore8$user2.sessionIdData; // if store state does not have sessionID check localStorage

                if ((_currentSessionData = currentSessionData) !== null && _currentSessionData !== void 0 && _currentSessionData.sessionID) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.getFromLocalStorage("CURRENT_USER_SESSION_ID");

              case 5:
                storedData = _context5.sent;
                currentSessionData = JSON.parse(storedData);
                (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$use = _this$rootStore10.user) === null || _this$rootStore10$use === void 0 ? void 0 : (_this$rootStore10$use2 = _this$rootStore10$use.analyticsModel) === null || _this$rootStore10$use2 === void 0 ? void 0 : _this$rootStore10$use2.setSessionIdData(currentSessionData);

              case 8:
                timeout = this.sessionIDExpirationThreshold * 60 * 1000;
                currentTime = moment();
                lastRequestFiredTime = moment(parseInt((_currentSessionData2 = currentSessionData) === null || _currentSessionData2 === void 0 ? void 0 : _currentSessionData2.timestamp, 10));

                if (!((_currentSessionData3 = currentSessionData) !== null && _currentSessionData3 !== void 0 && _currentSessionData3.sessionID) || // if there is no sessionID in localStorage or existing any in analyticsModel (Fresh Session)
                currentTime.diff(lastRequestFiredTime) >= timeout // if sessionID is older than timeout limit generate new one
                ) {
                  id = getUniqueSessionID(this === null || this === void 0 ? void 0 : (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$com = _this$rootStore11.common) === null || _this$rootStore11$com === void 0 ? void 0 : (_this$rootStore11$com2 = _this$rootStore11$com.appAttributes) === null || _this$rootStore11$com2 === void 0 ? void 0 : (_this$rootStore11$com3 = _this$rootStore11$com2.concept) === null || _this$rootStore11$com3 === void 0 ? void 0 : _this$rootStore11$com3.conceptCodeDesc);
                  data = {
                    sessionID: id,
                    timestamp: currentTime.valueOf().toString()
                  };
                  (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$pla = _this$rootStore12.platformUtil) === null || _this$rootStore12$pla === void 0 ? void 0 : _this$rootStore12$pla.saveInLocalStorage("CURRENT_USER_SESSION_ID", JSON.stringify(data));
                  (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$use = _this$rootStore13.user) === null || _this$rootStore13$use === void 0 ? void 0 : (_this$rootStore13$use2 = _this$rootStore13$use.analyticsModel) === null || _this$rootStore13$use2 === void 0 ? void 0 : _this$rootStore13$use2.setSessionIdData(data);
                }

                _context5.next = 16;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 14]]);
      }));

      function trackSession() {
        return _trackSession.apply(this, arguments);
      }

      return trackSession;
    }()
  }, {
    key: "showDeliveryErrorPopUp",
    value: function showDeliveryErrorPopUp(popUp) {
      if ((popUp === null || popUp === TOGO_DELIVERY_ERROR_POP_UP_TYPE.NONE) && this.promptResolveForTOGODeliveryFlow) {
        var _this$promptResolveFo;

        (_this$promptResolveFo = this.promptResolveForTOGODeliveryFlow) === null || _this$promptResolveFo === void 0 ? void 0 : _this$promptResolveFo.call(this);
      }

      this._userChoice = null;
      this._deliveryErrorPopUp = popUp;
    }
  }, {
    key: "processCreateGetQuoteError",
    value: function processCreateGetQuoteError(error) {
      var _error$errors, _error$errors$, _error$errors$0$title, _error$errors2, _error$errors2$, _error$errors3, _error$errors3$;

      var errorCode = (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.code;

      switch (errorCode) {
        case TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_UNAVAILABLE:
          {
            var _this$rootStore$deliv, _this$rootStore$deliv2, _this$rootStore$deliv3;

            this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_DELIVERY_UNAVAILABLE);
            (_this$rootStore$deliv = this.rootStore.delivery) === null || _this$rootStore$deliv === void 0 ? void 0 : (_this$rootStore$deliv2 = _this$rootStore$deliv.deliveryModel) === null || _this$rootStore$deliv2 === void 0 ? void 0 : (_this$rootStore$deliv3 = _this$rootStore$deliv2.setShowTogoDeliveryUnavailableErrorModal) === null || _this$rootStore$deliv3 === void 0 ? void 0 : _this$rootStore$deliv3.call(_this$rootStore$deliv2, true);
            break;
          }

        case TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CREATE_QUOTE_GENERIC_ERROR:
        default:
          this.rootStore.appMessages.showError((_error$errors$0$title = (_error$errors2 = error.errors) === null || _error$errors2 === void 0 ? void 0 : (_error$errors2$ = _error$errors2[0]) === null || _error$errors2$ === void 0 ? void 0 : _error$errors2$.title) !== null && _error$errors$0$title !== void 0 ? _error$errors$0$title : "Something Went Wrong", (_error$errors3 = error.errors) === null || _error$errors3 === void 0 ? void 0 : (_error$errors3$ = _error$errors3[0]) === null || _error$errors3$ === void 0 ? void 0 : _error$errors3$.message, null, {
            undismissible: true,
            okBtnText: "OK"
          });
      }
    }
  }, {
    key: "setUserChoiceForDeliveryTimeUpdate",
    value: function setUserChoiceForDeliveryTimeUpdate(choice) {
      this._userChoice = choice;
    }
  }, {
    key: "waitForUserChoiceTOGODeliveryTimeChange",
    value: function waitForUserChoiceTOGODeliveryTimeChange() {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.promptResolveForTOGODeliveryFlow = function () {
          return resolve(_this3._userChoice);
        };
      });
    }
  }, {
    key: "appAttributes",
    get: function get() {
      return this._appAttributes;
    }
  }, {
    key: "mobilePayLoginEnforced",
    get: function get() {
      var appAttributes = this.appAttributes;
      var isWebMobilePayLoginEnforced = appAttributes.isWebMobilePayLoginEnforced;
      var isMobilePayForVIPGuestsEnabled = appAttributes.isMobilePayForVIPGuestsEnabled;
      return isMobilePayForVIPGuestsEnabled || isWebMobilePayLoginEnforced;
    }
  }, {
    key: "timeAtAppActive",
    get: function get() {
      return this._timeAtAppActive;
    },
    set: function set(_timeAtAppActive) {
      var _this4 = this;

      runInAction(function () {
        _this4._timeAtAppActive = _timeAtAppActive;
      });
    }
  }, {
    key: "shouldShowGlobalBanner",
    get: function get() {
      var _this$rootStore14, _this$rootStore14$use;

      return this.isGlobalBannerMessageAvailableInRB || this.isCareersLinkAvailableInRB || this.isWelcomeBannerMessageAvailableInRB && (this === null || this === void 0 ? void 0 : (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$use = _this$rootStore14.user) === null || _this$rootStore14$use === void 0 ? void 0 : _this$rootStore14$use.isLoggedIn);
    }
  }, {
    key: "isGlobalBannerMessageAvailableInRB",
    get: function get() {
      return i18next.exists("header.richtext.globalBannerMessage") && !!i18next.t("header.richtext.globalBannerMessage");
    }
  }, {
    key: "isCareersLinkAvailableInRB",
    get: function get() {
      return i18next.exists("header.label.careers") && !!i18next.t("header.label.careers");
    }
  }, {
    key: "showPrivateDining",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.showPrivateDining) === "true";
    }
  }, {
    key: "isWelcomeBannerMessageAvailableInRB",
    get: function get() {
      return i18next.exists("header.richtext.welcomeBannerMessage") && !!i18next.t("header.richtext.welcomeBannerMessage");
    }
  }, {
    key: "headerLocationLinkText",
    get: function get() {
      var _this$rootStore15, _this$rootStore15$men, _this$rootStore15$men2, _window, _window$location, _window$location$href, _window2, _window2$location, _window2$location$hre, _window3, _window3$location, _window3$location$hre;

      var currentRestaurant = (_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$men = _this$rootStore15.menuList) === null || _this$rootStore15$men === void 0 ? void 0 : (_this$rootStore15$men2 = _this$rootStore15$men.orderSettingsModel) === null || _this$rootStore15$men2 === void 0 ? void 0 : _this$rootStore15$men2.currentRestaurant;
      var isJoinEclubFlow = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$href = _window$location.href) === null || _window$location$href === void 0 ? void 0 : _window$location$href.includes("join-eclub");
      var isMyAccountFlow = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$hre = _window2$location.href) === null || _window2$location$hre === void 0 ? void 0 : _window2$location$hre.includes("customer-service");
      var isPrivateDiningFlow = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : (_window3$location$hre = _window3$location.href) === null || _window3$location$hre === void 0 ? void 0 : _window3$location$hre.includes("private-dining");

      if ((isJoinEclubFlow || isPrivateDiningFlow || isMyAccountFlow) && currentRestaurant === null) {
        return "FIND RESTAURANT";
      }

      return "CHANGE LOCATION";
    }
  }, {
    key: "orderID",
    get: function get() {
      var _this$rootStore16, _this$rootStore16$use, _this$rootStore16$use2, _this$rootStore16$use3;

      return this._orderID || ((_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$use = _this$rootStore16.user) === null || _this$rootStore16$use === void 0 ? void 0 : (_this$rootStore16$use2 = _this$rootStore16$use.sessionDetails) === null || _this$rootStore16$use2 === void 0 ? void 0 : (_this$rootStore16$use3 = _this$rootStore16$use2.orderContext) === null || _this$rootStore16$use3 === void 0 ? void 0 : _this$rootStore16$use3.orderId);
    },
    set: function set(_orderID) {
      var _this5 = this;

      runInAction(function () {
        _this5._orderID = _orderID;
      });
    }
  }, {
    key: "sessionIDExpirationThreshold",
    get: function get() {
      var _this$appAttributes, _this$appAttributes$c, _this$appAttributes2, _this$appAttributes2$;

      return isTrue((_this$appAttributes = this.appAttributes) === null || _this$appAttributes === void 0 ? void 0 : (_this$appAttributes$c = _this$appAttributes.configs) === null || _this$appAttributes$c === void 0 ? void 0 : _this$appAttributes$c.sessionIDExpirationThreshold, Number((_this$appAttributes2 = this.appAttributes) === null || _this$appAttributes2 === void 0 ? void 0 : (_this$appAttributes2$ = _this$appAttributes2.configs) === null || _this$appAttributes2$ === void 0 ? void 0 : _this$appAttributes2$.sessionIDExpirationThreshold), 20);
    }
  }, {
    key: "deliveryErrorPopUp",
    get: function get() {
      return this._deliveryErrorPopUp;
    }
  }]);

  return Common;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_timeAtAppActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_orderID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_deliveryErrorPopUp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return TOGO_DELIVERY_ERROR_POP_UP_TYPE.NONE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_userChoice", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "appAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobilePayLoginEnforced", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobilePayLoginEnforced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeAtAppActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeAtAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowGlobalBanner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowGlobalBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGlobalBannerMessageAvailableInRB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGlobalBannerMessageAvailableInRB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCareersLinkAvailableInRB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCareersLinkAvailableInRB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPrivateDining", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPrivateDining"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWelcomeBannerMessageAvailableInRB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWelcomeBannerMessageAvailableInRB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "headerLocationLinkText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "headerLocationLinkText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionIDExpirationThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionIDExpirationThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryErrorPopUp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryErrorPopUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeliveryErrorPopUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showDeliveryErrorPopUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserChoiceForDeliveryTimeUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserChoiceForDeliveryTimeUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitForUserChoiceTOGODeliveryTimeChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "waitForUserChoiceTOGODeliveryTimeChange"), _class.prototype)), _class);
export { Common as default };